import { FC } from 'react';
import { getEnvironment } from '@minecraft.environment';
import { useFrontChatWidget } from './Front/useFrontChatWidget';

type Props = {
  shouldHide?: boolean;
  bypassPermissionsCheck?: boolean;
};

const FrontChatSupportWidget: FC<Props> = ({ shouldHide, bypassPermissionsCheck }) => {
  const env = getEnvironment();
  const chatId = env['FRONT_CHAT_ID'];

  useFrontChatWidget({
    chatId,
    bypassPermissionsCheck,
    shouldHide,
  });

  return null;
};

export const ChatSupportProvider: FC<Props> = ({ shouldHide, bypassPermissionsCheck }) => {
  return <FrontChatSupportWidget shouldHide={shouldHide} bypassPermissionsCheck={bypassPermissionsCheck} />;
};
